// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"106":"720e5bba","571":"720e5bba"}[chunkId] + ".chunk.css";
};